import { gql } from '@apollo/client';

export const USERS_CLINIC_ADMIN_UPDATE = gql`
  mutation updateUserClinicAdmin($input: UpdateUserClinicAdminInput!) {
    updateUserClinicAdmin(input: $input) {
      id
      email
      nameFirst
      nameLast
      active
      emailVerified
      role {
        id
        name
        nameDisplay
        permissions
      }
      acl {
        clinicId
        clinics
      }
    }
  }
`;

export const USERS_CLINIC_ADMIN_DELETE = gql`
  mutation deleteUserClinicAdmin($userId: ID!) {
    deleteUserClinicAdmin(userId: $userId)
  }
`;

export const USERS_CLINICIAN_DELETE = gql`
  mutation deleteUserClinician($userId: ID!) {
    deleteUserClinician(userId: $userId)
  }
`;

export const PROMOTE_TO_SUPER_CLINICIAN = gql`
  mutation promoteToSuperClinician($clinicianId: ID!) {
    promoteToSuperClinician(clinicianId: $clinicianId) {
      id
    }
  }
`;

export const DEMOTE_TO_REGULAR_CLINICIAN = gql`
  mutation demoteToRegularClinician($clinicianId: ID!) {
    demoteToRegularClinician(clinicianId: $clinicianId) {
      id
    }
  }
`;

export const ACTIVATE_AND_UPDATE_USER = gql`
  mutation activateAndUpdateUser(
    $activationToken: String!
    $password: Password!
    $nameFirst: String
    $nameLast: String
  ) {
    activateAndUpdateUser(
      input: {
        activationToken: $activationToken
        password: $password
        nameFirst: $nameFirst
        nameLast: $nameLast
      }
    ) {
      id
      email
      nameFirst
      nameLast
      active
      emailVerified
      roleId
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: Email!) {
    forgotPassword(email: $email)
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($token: String!, $password: Password!) {
    resetPassword(token: $token, password: $password) {
      id
      email
      nameFirst
      nameLast
      active
      emailVerified
      locked
      type
      roleId
      tz
    }
  }
`;

export const LOGIN = gql`
  mutation login($email: Email!, $password: Password!) {
    login(email: $email, password: $password) {
      userId
      accessToken
      refreshToken
    }
  }
`;
